<template>
  <nav-header :title="title"></nav-header>
  <main class="statistics-page">
    <div class="container statistics-container statistics-stack">
      <template v-if="apiData != null">
        <section class="statistics-panel">
          <div class="statistics-heading">
            <span class="statistics-heading-icon" aria-hidden="true">
              <i class="material-icons">query_stats</i>
            </span>
            <h2>{{ $englishPreferred ? "My counts" : "Mine tællinger" }}</h2>
          </div>

          <div class="statistics-period-grid">
            <article class="statistics-period-card">
              <h3>{{ $englishPreferred ? "All time" : "I alt" }}</h3>
              <div class="statistics-metric-row">
                <div>
                  <span class="statistics-metric-label">{{ $englishPreferred ? "Amount" : "Antal" }}</span>
                  <strong class="statistics-metric-value">{{ apiData.totalCounts }}</strong>
                </div>
                <router-link class="statistics-ranking-link" to="/statistik/rang/taellinger/total">
                  {{ $englishPreferred ? "Ranking" : "Rangliste" }}
                  <i class="material-icons" aria-hidden="true">military_tech</i>
                </router-link>
              </div>
              <div v-if="seePoints == 'true'" class="statistics-metric-row">
                <div>
                  <span class="statistics-metric-label">Point</span>
                  <strong class="statistics-metric-value">{{ apiData.totalPoints }}</strong>
                </div>
                <router-link class="statistics-ranking-link" to="/statistik/rang/point/total">
                  {{ $englishPreferred ? "Ranking" : "Rangliste" }}
                  <i class="material-icons" aria-hidden="true">military_tech</i>
                </router-link>
              </div>
            </article>

            <article class="statistics-period-card">
              <h3>{{ currentYear }}</h3>
              <div class="statistics-metric-row">
                <div>
                  <span class="statistics-metric-label">{{ $englishPreferred ? "Amount" : "Antal" }}</span>
                  <strong class="statistics-metric-value">{{ apiData.totalCountsCurrentYear }}</strong>
                </div>
                <router-link class="statistics-ranking-link" to="/statistik/rang/taellinger/aar">
                  {{ $englishPreferred ? "Ranking" : "Rangliste" }}
                  <i class="material-icons" aria-hidden="true">military_tech</i>
                </router-link>
              </div>
              <div v-if="seePoints == 'true'" class="statistics-metric-row">
                <div>
                  <span class="statistics-metric-label">Point</span>
                  <strong class="statistics-metric-value">{{ apiData.totalPointsCurrentYear }}</strong>
                </div>
                <router-link class="statistics-ranking-link" to="/statistik/rang/point/aar">
                  {{ $englishPreferred ? "Ranking" : "Rangliste" }}
                  <i class="material-icons" aria-hidden="true">military_tech</i>
                </router-link>
              </div>
            </article>

            <article class="statistics-period-card">
              <h3>{{ $englishPreferred ? "Recent 30 days" : "Seneste 30 dage" }}</h3>
              <div class="statistics-metric-row">
                <div>
                  <span class="statistics-metric-label">{{ $englishPreferred ? "Amount" : "Antal" }}</span>
                  <strong class="statistics-metric-value">{{ apiData.totalCounts30Days }}</strong>
                </div>
                <router-link class="statistics-ranking-link" to="/statistik/rang/taellinger/30">
                  {{ $englishPreferred ? "Ranking" : "Rangliste" }}
                  <i class="material-icons" aria-hidden="true">military_tech</i>
                </router-link>
              </div>
              <div v-if="seePoints == 'true'" class="statistics-metric-row">
                <div>
                  <span class="statistics-metric-label">Point</span>
                  <strong class="statistics-metric-value">{{ apiData.totalPoints30Days }}</strong>
                </div>
                <router-link class="statistics-ranking-link" to="/statistik/rang/point/30">
                  {{ $englishPreferred ? "Ranking" : "Rangliste" }}
                  <i class="material-icons" aria-hidden="true">military_tech</i>
                </router-link>
              </div>
            </article>
          </div>
        </section>

        <section class="statistics-panel">
          <div class="statistics-heading">
            <span class="statistics-heading-icon" aria-hidden="true">
              <i class="material-icons">grid_view</i>
            </span>
            <h2>{{ $englishPreferred ? "Covered squares" : "Dækkede kvadrater" }}</h2>
          </div>
          <div class="statistics-coverage-grid">
            <article class="statistics-coverage-card">
              <i class="material-icons" aria-hidden="true">check_circle</i>
              <div>
                <span class="statistics-coverage-label">{{ $englishPreferred ? "All time" : "I alt" }}</span>
                <strong class="statistics-coverage-value">{{ apiData.coveredSquaresTotal }} / 2255</strong>
              </div>
            </article>
            <article class="statistics-coverage-card">
              <i class="material-icons" aria-hidden="true">check_circle</i>
              <div>
                <span class="statistics-coverage-label">{{ currentYear }}</span>
                <strong class="statistics-coverage-value">{{ apiData.coveredSquaresCurrentYear }} / 2255</strong>
              </div>
            </article>
            <article class="statistics-coverage-card">
              <i class="material-icons" aria-hidden="true">check_circle</i>
              <div>
                <span class="statistics-coverage-label">{{ $englishPreferred ? "Recent 30 days" : "Seneste 30 dage" }}</span>
                <strong class="statistics-coverage-value">{{ apiData.coveredSquares30Days }} / 2255</strong>
              </div>
            </article>
          </div>
        </section>

        <router-link to="/statistik/projekt" class="statistics-primary-link">
          <i class="material-icons" aria-hidden="true">public</i>
          {{ $englishPreferred ? "General project statistics" : "Generel projektstatistik" }}
        </router-link>
      </template>
      <div v-else class="statistics-panel statistics-empty-state">
        {{ $englishPreferred ? "Fetching statistics" : "Henter statistik" }}...
      </div>
    </div>
  </main>
</template>

<script>
import NavHeader from "@/components/navbars/NavHeader.vue";
import moment from "moment";
import axios from "axios";

export default {
  components: {
    NavHeader,
  },
  data() {
    return {
      online: true,
      title: this.$englishPreferred ? "My statistics" : "Min statistik",
      currentYear: new Date().getFullYear(),
      apiData: null,
      seePoints: "true",
      moment: moment,
    };
  },
  methods: {
    async getIndividualStatistics() {
      return axios.get("/spontan/ranking/statistics/individual");
    },

    async prepareData() {
      this.getIndividualStatistics()
        .then((response) => {
          this.apiData = response.data;
        })
        .catch(() => {
          console.log("Server did not respond, updating locally");
          this.online = false;
          this.apiData = 0;
        });
    },
  },

  mounted() {
    this.prepareData();
    if ($cookies.isKey("seePoints")) {
      this.seePoints = $cookies.get("seePoints");
    }
  },
};
</script>

<style scoped>
:deep(#navbar) {
  margin-bottom: 0 !important;
}
</style>
